import { RouteFactory } from "@app/routePaths";
import { usePreferredEdition } from "@hooks/usePreferredEdition";

/**
 * Hook to get the link for the homepage masthead based on the user's preferred edition.
 */
export const useHomeLink = () => {
  const { isSgPreferred } = usePreferredEdition();

  if (isSgPreferred) return RouteFactory.home;

  return RouteFactory.global;
};
